import { combineReducers } from "redux";
import getincomeAttributesReducer from "./getIncomeAttributesReducer";
import putIncomeAttributesReducer from "./putIncomeAttributesReducer";
import getPreviousIncomeAttributesReducer from "./getPreviousIncomeAttributesReduer";
import getPreviousIncomeAttributesInternalReducer from "./getPreviousIncomeAttributesInternalReducer";

const incomeAttributesReducer = combineReducers({
    incomeAttributes: getincomeAttributesReducer,
    putIncomeAttributes: putIncomeAttributesReducer,
    previousIncomeAttributes: getPreviousIncomeAttributesReducer,
    previousIncomeAttributesInternal: getPreviousIncomeAttributesInternalReducer
});

export default incomeAttributesReducer;